.stage-content {
    height: calc(100% - 82px); /* 82px is the height of the footer bar */
    width: 100%;
}

.illustration-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.find-potential-contacts-execute-page-container {
    height: 100%;
    overflow-y: auto;
}
